import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxHeart } from "@fortawesome/pro-solid-svg-icons";

import { boltIcon, percentIcon } from "@/utils/svg";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

export const HIGHLIGHTS_EXCLUSIVE = [
  {
    id: "selo-black-friday",
    label:
      "<strong class='tag-black-friday'>BLACK <span class='friday'>FRIDAY</span></strong>",
    color: "var(--token-colors-neutral-cloud-white)",
    bgColor: "var(--token-colors-neutral-lnk-darker)",
    icon: ""
  },
  {
    id: "selo-meu-desconto-5%",
    label: "Ative 5% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-7%",
    label: "Ative 7% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-10%",
    label: "Ative 10% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-15%",
    label: "Ative 15% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-20%",
    label: "Ative 20% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-25%",
    label: "Ative 25% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-30%",
    label: "Ative 30% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-35%",
    label: "Ative 35% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-40%",
    label: "Ative 40% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-45%",
    label: "Ative 45% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-50%",
    label: "Ative 50% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-60%",
    label: "Ative 60% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-70%",
    label: "Ative 70% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-90%",
    label: "Ative 90% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "selo-meu-desconto-95%",
    label: "Ative 95% OFF no App",
    color: "var(--token-cobasi-colors-orange-primary)",
    bgColor: "var(--token-cobasi-colors-orange-light)",
    icon: percentIcon
  },
  {
    id: "plantas-e-alimentos---apenas-retira",
    label: "Exclusivo para retirar na loja",
    color: "var(--token-cobasi-colors-turquoise-primary)",
    bgColor: "var(--token-cobasi-colors-turquoise-light)",
    icon: ""
  },
  {
    id: "selo-produtos-exclusivos---correto",
    label: "Só na Cobasi",
    color: "var(--token-cobasi-colors-coffee-primary)",
    bgColor: "var(--token-cobasi-colors-coffee-light)",
    icon: <FontAwesomeIcon icon={faBoxHeart as IconProp} />
  },
  {
    id: "oferta-turbinada-5%-off",
    label: "Ative + 5% OFF no App",
    color: "#FFFFFF",
    bgColor: "#000000",
    icon: percentIcon
  },
  {
    id: "oferta-turbinada-10%-off",
    label: "Ative + 10% OFF no App",
    color: "#FFFFFF",
    bgColor: "#000000",
    icon: percentIcon
  },
  {
    id: "oferta-turbinada-15%-off",
    label: "Ative + 15% OFF no App",
    color: "#FFFFFF",
    bgColor: "#000000",
    icon: percentIcon
  },
  {
    id: "oferta-turbinada-20%-off",
    label: "Ative + 20% OFF no App",
    color: "#FFFFFF",
    bgColor: "#000000",
    icon: percentIcon
  },
  {
    id: "oferta-turbinada-25%-off",
    label: "Ative + 25% OFF no App",
    color: "#FFFFFF",
    bgColor: "#000000",
    icon: percentIcon
  },
  {
    id: "oferta-turbinada-30%-off",
    label: "Ative + 30% OFF no App",
    color: "#FFFFFF",
    bgColor: "#000000",
    icon: percentIcon
  }
];

export const HIGHLIGHTS = [
  {
    id: "selo-para-humanos",
    label: "Para Humanos",
    color: "#FFF3E6",
    bgColor: "#FF6500",
    icon: ""
  },
  {
    id: "selo-compre-e-ganhe",
    label: "Compre e Ganhe",
    color: "var(--token-colors-neutral-cloud-white)",
    bgColor: "var(--token-cobasi-colors-turquoise-primary)",
    icon: boltIcon
  },
  {
    id: "selo-desconto",
    label: "Desconto",
    color: "var(--token-cobasi-colors-turquoise-primary)",
    bgColor: "var(--token-cobasi-colors-turquoise-light)",
    icon: ""
  },
  {
    id: "selo-leve-mais-pague-menos",
    label: "Leve Mais, Pague Menos",
    color: "var(--token-colors-neutral-cloud-white)",
    bgColor: "var(--token-cobasi-colors-turquoise-primary)",
    icon: boltIcon
  },
  {
    id: "market-place---frete-gratis-brasil",
    label: "Frete Grátis Brasil​",
    color: "#FFF3E6",
    bgColor: "#FF6500",
    icon: ""
  },
  {
    id: "marketplace---frete-grátis-brasil",
    label: "Frete Grátis Brasil​",
    color: "#F29217",
    bgColor: "#FF6500",
    icon: ""
  },
  {
    id: "market-place---frete-gratis-sul-sudeste",
    label: "Frete Grátis Sul/Sudeste​",
    color: "#FFF3E6",
    bgColor: "#FF6500",
    icon: ""
  },
  {
    id: "marketplace---frete-grátis-sul-e-sudeste",
    label: "Frete Grátis Sul/Sudeste​",
    color: "#FFF3E6",
    bgColor: "#FF6500",
    icon: ""
  },
  {
    id: "produto-internacional",
    label: "Produto Internacional",
    color: "#FFFFFF",
    bgColor: "#00B2C6",
    icon: ""
  },
  {
    id: "selo-lançamento",
    label: "Lançamento",
    color: "var(--token-cobasi-colors-orange-light)",
    bgColor: "var(--token-cobasi-colors-orange-primary)",
    icon: ""
  },
  {
    id: "selo-melhor-preço",
    label: "Melhor custo-benefício",
    color: "var(--token-cobasi-colors-turquoise-primary)",
    bgColor: "var(--token-cobasi-colors-turquoise-light)",
    icon: ""
  },
  {
    id: "selo-oferta-do-dia",
    label: "Oferta do Dia",
    color: "var(--token-cobasi-colors-orange-light)",
    bgColor: "var(--token-cobasi-colors-orange-primary)",
    icon: ""
  },
  {
    id: "selo-vencimento-curto",
    label: "Próximo ao vencimento",
    color: "var(--token-colors-neutral-cloud-white)",
    bgColor: "var(--token-colors-status-warning-primary)",
    icon: ""
  }
];
